export default __webpack_public_path__ + "static/media/our-people.3052bdec.png";